import React from 'react';
import { PageTransitionWrapper } from '../../../../components';
import { Box, Stack, Typography } from '@mui/material';
import SelectionButtons from '../SelectionButtons';
import { ScheduleDialog } from '../../../../components';
import { VideoInterviewDialog } from '../VideoInterviewDialog';
import { VideoInterviewInstructions } from '../VideoInterviewInstructions';
import { MatchingVIPosition } from 'src/types/videoInterviewData';
import { VideoInterviewSelectableList } from '../VideoInterviewSelectableList/VideoInterviewSelectableList';

interface IProps {
  handleCloseScheduleForLater: () => void;
  handleScheduleSuccess: () => void;
  handleStartRecord: (e: React.SyntheticEvent | null) => void;
  handleAddToCalendar: () => void;
  handleStartVideoInterviewNow: () => void;
  showScheduleDialog: boolean;
  showRescheduleMessage: boolean;
  handleSkipVideoInterview: (e: React.SyntheticEvent | null) => void;
  showVIDialog: boolean;
  setShowVIDialog: (showVIDialog: boolean) => void;
  isIndependentVIPage: boolean;
  availableVideoInterview: MatchingVIPosition[] | null;
  handleSelectVideoInterview: (value: MatchingVIPosition) => void;
  isUserSkippedVideoInterview: boolean;
  selectedVI: MatchingVIPosition | null;
}

const TechVideoInterviewSelection: React.FC<IProps> = ({
  handleCloseScheduleForLater,
  handleScheduleSuccess,
  handleStartRecord,
  handleAddToCalendar,
  handleStartVideoInterviewNow,
  showScheduleDialog,
  showRescheduleMessage,
  handleSkipVideoInterview,
  showVIDialog,
  setShowVIDialog,
  isIndependentVIPage,
  availableVideoInterview,
  handleSelectVideoInterview,
  selectedVI,
}) => {
  const isMatchedPositionsVI =
    availableVideoInterview && availableVideoInterview?.length >= 1;

  const hasOptionalVI = availableVideoInterview?.some((vi) => !vi.isRequired);

  return (
    <>
      {showScheduleDialog && (
        <ScheduleDialog
          isOpen={showScheduleDialog}
          handleClose={handleCloseScheduleForLater}
          handleScheduleSuccess={handleScheduleSuccess}
          isVideoInterview={true}
        />
      )}
      {showVIDialog && (
        <VideoInterviewDialog
          isOpen={showVIDialog}
          handleClose={() => setShowVIDialog(false)}
          handleStartRecord={handleStartRecord}
          handleSkipSelection={handleSkipVideoInterview}
          handleCalendar={handleAddToCalendar}
          showSkipButton={!isIndependentVIPage && hasOptionalVI}
          selectedVI={selectedVI}
        />
      )}
      <PageTransitionWrapper>
        <Box data-testid="tech-video-interview-selection-layout">
          <Stack
            sx={(theme) => ({
              [theme.breakpoints.down('lg')]: {
                flexDirection: 'column',
              },
              [theme.breakpoints.up('lg')]: {
                flexDirection: 'row',
              },
            })}
          >
            <Stack
              sx={(theme) => ({
                [theme.breakpoints.up('lg')]: {
                  minWidth: '32rem',
                  maxWidth: '37rem',
                },
              })}
            >
              <Box sx={{ position: 'relative' }}>
                <Typography
                  variant="h2"
                  mb={2}
                  mt={3.5}
                  sx={(theme) => ({
                    [theme.breakpoints.down('sm')]: {
                      fontSize: '1.25rem',
                      fontWeight: 600,
                    },
                  })}
                >
                  Showcase your communication <br />
                  skills in a short video
                </Typography>
              </Box>
              <VideoInterviewInstructions isTech={true} />
              {isMatchedPositionsVI && (
                <VideoInterviewSelectableList
                  availableVideoInterview={availableVideoInterview}
                  handleSelectVideoInterview={handleSelectVideoInterview}
                  selectedVIPosition={selectedVI?.id || null}
                />
              )}

              {!isMatchedPositionsVI && (
                <Typography variant="body1" marginTop="1rem">
                  We’re excited to get to know you better and sooner!
                </Typography>
              )}

              <SelectionButtons
                handleStartVideoInterview={handleStartVideoInterviewNow}
                handleSkipSelection={handleSkipVideoInterview}
                handleSubmitStep={() => {
                  setShowVIDialog(true);
                }}
                handleCalendar={handleAddToCalendar}
                showRescheduleMessage={showRescheduleMessage}
              />
            </Stack>
          </Stack>
        </Box>
      </PageTransitionWrapper>
    </>
  );
};

export default TechVideoInterviewSelection;
